import { Point } from '../../util';
import { TextLayerSpecification } from '../chart-props';
import { VectorDrawFunction } from './type';

export const drawTextLayer: VectorDrawFunction<TextLayerSpecification> = (pass, features, layer, xAxis, yAxis) => {
    pass.drawer.setFont(pass.getFont(null));
    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (layer.filter && !layer.filter(feature, i)) {
            continue;
        }

        const text = feature.properties?.[layer.paint.textField];
        if (!text) {
            continue;
        }

        let point: Point | undefined;
        if (feature.geometry.type === 'Polygon') {
            // FIXME: this assumes we're dealing with rectangles with points provided in a specific order
            const x1 = xAxis.project(feature.geometry.coordinates[0][0], pass.viewState);
            const y1 = yAxis.project(feature.geometry.coordinates[0][1], pass.viewState);
            const x2 = xAxis.project(feature.geometry.coordinates[2][0], pass.viewState);
            const y2 = yAxis.project(feature.geometry.coordinates[2][1], pass.viewState);
            point = [x1 + (x2 - x1) / 2, y1 + (y2 - y1) / 2];

            // TODO: This will move the label along the rectangle if the center point is outside of the viewport, but we need to take into account text dimensions
            //if (!pass.chartViewport.contains(point[0], point[1])) {
            //    const shift = pass.chartViewport.left2 - point[0];
            //    if (point[0] + shift < x2) {
            //        point[0] += shift;
            //    }
            //}
        } else if (feature.geometry.type === 'Point') {
            point = [
                xAxis.project(feature.geometry.coordinates[0], pass.viewState),
                yAxis.project(feature.geometry.coordinates[1], pass.viewState)
            ];
        }

        if (point) {
            const id = layer.id + '.' + (feature.id ?? i);
            if (pass.isRendering) {
                const placement = pass.placement.get(id);
                if (placement) {
                    point[0] += placement.offset[0];
                    point[1] += placement.offset[1];
                }
                pass.drawer.drawText(
                    text,
                    point,
                    {
                        alignment: 'center',
                        baseline: 'middle'
                    },
                    {
                        color: layer.paint.color
                    }
                );
            } else {
                const size = pass.drawer.ctx.measureText(text);
                pass.placement.add({
                    id,
                    anchor: point,
                    width: size.width,
                    height: 10,
                    priority: 0,
                    padding: 5,
                    bounds: [0, 0, 0, 0] // TODO
                });
            }
        }
    }
};
